import React from 'react';

import { SortableTable } from '~/components/core';
import EmptyState from '~/components/core/EmptyState';
import { PencilIcon, TrashIcon } from '~/components/icons';
import InlineIconButtonUntyped from '~/components/InlineIconButton';

import TEXTS from './texts';
import type { PredefinedPromptRow } from './types';

interface InlineIconButtonProps {
  icon: React.ElementType;
  tooltipTitle?: string;
  ariaLabel?: string;
  onClick?: () => void;
  disabled?: boolean;
}
const InlineIconButton = InlineIconButtonUntyped as React.ComponentType<InlineIconButtonProps>;

interface PredefinedPromptsTableProps {
  rows: PredefinedPromptRow[];
  onEdit: (row: PredefinedPromptRow) => void;
  onDelete: (row: PredefinedPromptRow) => void;
}

const PredefinedPromptsTable: React.FC<PredefinedPromptsTableProps> = ({ rows, onEdit, onDelete }) => {
  const columns = [
    { id: 'prompt_key', label: TEXTS.columns.key, numeric: false },
    { id: 'prompt_title', label: TEXTS.columns.title, numeric: false },
    {
      id: 'prompt_text',
      label: TEXTS.columns.text,
      numeric: false,
      disableSort: true,
      specialCell: (row: PredefinedPromptRow) => (
        <div className="line-clamp-3 max-w-[480px] whitespace-pre-wrap">{row.prompt_text}</div>
      ),
    },
    {
      id: 'edit',
      label: TEXTS.columns.edit,
      disableSort: true,
      specialCell: (row: PredefinedPromptRow) => (
        <InlineIconButton
          icon={PencilIcon}
          tooltipTitle={TEXTS.columns.edit}
          ariaLabel={`Edit ${row.prompt_key}`}
          onClick={() => onEdit(row)}
        />
      ),
    },
    {
      id: 'delete',
      label: TEXTS.columns.delete,
      disableSort: true,
      specialCell: (row: PredefinedPromptRow) => (
        <InlineIconButton
          icon={TrashIcon}
          tooltipTitle={TEXTS.columns.delete}
          ariaLabel={`Delete ${row.prompt_key}`}
          onClick={() => onDelete(row)}
        />
      ),
    },
  ];

  return (
    <SortableTable
      columns={columns}
      rows={rows}
      emptyStateComponent={<EmptyState title={TEXTS.emptyState.title} subtitle={TEXTS.emptyState.subtitle} />}
    />
  );
};

export default PredefinedPromptsTable;
